import type { AuthStoreGet, AuthStoreSet } from './auth.types';
import { createSessionActions } from './auth.sessionActions';
import { createSignInActions } from './auth.signInActions';
import { createSignupActions } from './auth.signupActions';
import { createLifecycleActions } from './auth.lifecycleActions';
import { createOperatorActions } from './auth.operatorActions';

/**
 * Composes the auth slice for Zustand. Logic lives in co-located modules
 * to keep this entry file small and navigable.
 */
export const createAuthActions = (set: AuthStoreSet, get: AuthStoreGet) => ({
  ...createSessionActions(set, get),
  ...createOperatorActions(set, get),
  ...createSignInActions(set, get),
  ...createSignupActions(set, get),
  ...createLifecycleActions(set, get),
});
